// /src/api/api.js
import axios from 'axios';
import { getAuth } from 'firebase/auth';

// Set the base URL for your API (replace this with your actual backend URL)
const BASE_URL = 'https://rocketprep-backend-399338419505.us-west2.run.app'; // example, if using FastAPI/Django backend

export const fetchSessions = async () => {
  try {
    const auth = getAuth();
    const user = auth.currentUser;

    if (!user) {
      throw new Error("User not logged in");
    }

    const idToken = await user.getIdToken();

    const response = await axios.get(
      `${BASE_URL}/review/get-sessions`,
      {
        headers: {
          Authorization: `Bearer ${idToken}`,
        },
      }
    );

    return response.data; // Sessions data
  } catch (error) {
    console.error('Error fetching sessions:', error);
    throw error;
  }
};

export const fetchSessionReview = async (sessionId) => {
  try {
    const auth = getAuth();
    const user = auth.currentUser;

    if (!user) {
      throw new Error("User not logged in");
    }

    const idToken = await user.getIdToken();

    const response = await axios.get(
      `${BASE_URL}/review/get-session-review/${sessionId}`, // RENAMED ENDPOINT
      {
        headers: {
          Authorization: `Bearer ${idToken}`,
        },
      }
    );

    return response.data; // Full session data including questions
  } catch (error) {
    console.error(`Error fetching session review for ${sessionId}:`, error);
    throw error;
  }
};

export const fetchGeneralReview = async () => {
  try {
    const auth = getAuth();
    const user = auth.currentUser;

    if (!user) {
      throw new Error("User not logged in");
    }

    const idToken = await user.getIdToken();
    const response = await axios.get(
      `${BASE_URL}/review/get-general-review`,
      {
        headers: {
          Authorization: `Bearer ${idToken}`
        },
      }
    );

    return response.data;
  } catch (error) {
    console.error(`Error fetching general review : `, error);
    throw error;
  }
}

export const fetchAiReview = async (sessionId) => {
  try {
    const auth = getAuth();
    const user = auth.currentUser;

    if (!user) {
      throw new Error("User not logged in");
    }

    const idToken = await user.getIdToken();
    const response = await axios.post(
      `${BASE_URL}/review/generate-session-review/${sessionId}`,
      {
        session_id: sessionId
      },
      {
        headers: {
          Authorization: `Bearer ${idToken}`,
        },
      }
    );

    return response.data;
  }
  catch (error) {
    console.error("Error generating AI session review:", error);
    throw error;
  }
}

// Example function to fetch a question for the test session
export const fetchQuestion = async (sessionId) => {
  try {
    const auth = getAuth();
    const user = auth.currentUser;

    if (!user) {
      throw new Error("User not logged in");
    }

    const idToken = await user.getIdToken();

    const response = await axios.post(
      `${BASE_URL}/study/get-question`,
      {
        session_id: sessionId,
      },
      {
        headers: {
          Authorization: `Bearer ${idToken}`,
        },
      }
    );

    return response.data; // Question data
  } catch (error) {
    console.error('Error fetching question:', error);
    throw error;
  }
};
// Example function to submit an answer and get a grading response
export const submitAnswer = async (sessionId, questionId, selectedAnswer) => {
  try {
    const auth = getAuth();
    const user = auth.currentUser;

    if (!user) {
      throw new Error("User not logged in");
    }

    const idToken = await user.getIdToken();
    const response = await axios.post(`${BASE_URL}/study/submit-answer`, {
      session_id: sessionId,
      question_id: questionId,
      selected_answer: selectedAnswer,

    },
    {
      headers: {
        Authorization: `Bearer ${idToken}`
      }
    });
    return response.data; // Return the grading response from the backend
  } catch (error) {
    console.error('Error submitting answer:', error);
    throw error;
  }
};

// Example function to create a new study session
export const createStudySession = async (testType, selectedSection, selectedSkills = [], difficulty, mode) => {
  try {
    const auth = getAuth();
    const user = auth.currentUser;

    if (!user) {
      throw new Error("User not logged in");
    }

    const idToken = await user.getIdToken();

    const response = await axios.post(
      `${BASE_URL}/study/create-session`,
      {
        test_type: testType,
        section: selectedSection,
        skills: selectedSkills,
        difficulty: difficulty,
        mode: mode,
      },
      {
        headers: {
          Authorization: `Bearer ${idToken}`
        }
      }
    );

    return response.data;
  } catch (error) {
    console.error('Error creating study session:', error);
    throw error;
  }
};

export const storeCompletedQuestion = async (sessionId, questionData) => {
  try {
    const auth = getAuth();
    const user = auth.currentUser;

    if (!user) {
      throw new Error("User not logged in");
    }

    const idToken = await user.getIdToken();

    const response = await axios.post(
      `${BASE_URL}/study/store-completed-question`,
      {
        session_id: sessionId,
        question_data: questionData
      },
      {
        headers: {
          Authorization: `Bearer ${idToken}`,
        },
      }
    );

    return response.data; // Or any relevant data from the response
  } catch (error) {
    console.error('Error storing completed question:', error);
    throw error;
  }
};

export const fetchUserPerformance = async () => {
  try {
    const auth = getAuth();
    const user = auth.currentUser;

    if (!user) {
      throw new Error("User not logged in");
    }

    const idToken = await user.getIdToken();

    const response = await axios.get(
      `${BASE_URL}/user/get-user-performance`,
      {
        headers: {
          Authorization: `Bearer ${idToken}`,
        },
      }
    );

    return response.data; // Performance data with skill scores
  } catch (error) {
    console.error('Error fetching user performance:', error);
    throw error;
  }
};
